import { render, staticRenderFns } from "./order.vue?vue&type=template&id=4f6e11c4&scoped=true&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"
import style0 from "./order.vue?vue&type=style&index=0&id=4f6e11c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6e11c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f6e11c4')) {
      api.createRecord('4f6e11c4', component.options)
    } else {
      api.reload('4f6e11c4', component.options)
    }
    module.hot.accept("./order.vue?vue&type=template&id=4f6e11c4&scoped=true&", function () {
      api.rerender('4f6e11c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/point_shop/order.vue"
export default component.exports